export default function service<T>(name: string, Class: new () => T): T {
    const instance = new Class();

    Object.assign(window, { [name]: instance });

    return instance;
}
